import API from 'util/API';

export const importProject = async (project) =>
  await API.save('importedProjects/', {id: project.id});

export const saveImportedProject = async (importedProject) =>
  await API.save('importedProjects/update/', importedProject);

export const findProjects = async () => await API.find('cnsObjects/new');

export const findAllImportedProjects = async () => await API.find('importedProjects/');

export const findImportedProjectById = async (id) => await API.find(`importedProjects/${id}`);

export const findProjectDocuments = async (projectNumber) =>
  await API.find(`documents/${projectNumber}`);

export const findimportedProjectMilestones = async (id) =>
  await API.find(`importedProjects/${id}/milestones`);

export const findImportedProjectProcedureMilestones = async (id) =>
  await API.find(`importedProjects/${id}/proceduresMilestones`);

export const findAllMilestones = async () => await API.find('milestones/');

export const saveImportedProcedure = async (importedProcedure) =>
  API.save('importedProcedures/', importedProcedure);

export const findImportedProcedures = async () => await API.find(`importedProcedures`);

export const findImportedProcedureById = async (importedProcedureId) =>
  await API.find(`importedProcedures/${importedProcedureId}`);

export const findCnsProcedures = async () => await API.find('cnsProcedures/new');

export const findCnsProcedureById = async (cnsProcedureId) =>
  await API.find(`cnsProcedures/${cnsProcedureId}`);
